import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

class Page extends Component {
    static propTypes = {
        className: PropTypes.string,
        children: PropTypes.any.isRequired,
        id: PropTypes.string,
        onClick: PropTypes.func
    };

    render() {
        return (
            <div id={this.props.id} className={cns('page', this.props.className)} onClick={this.props.onClick}>
                {this.props.children}
            </div>
        );
    }
}

export default Page;
